import { Component, Inject, OnInit } from '@angular/core';
import { UntilDestroy } from "@ngneat/until-destroy";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface DialogData {
  body: string;
  showOk: boolean;
  errors: string[];
  fieldErrors: boolean;
}

@UntilDestroy()
@Component({
  selector: 'app-op-confirm-dialog',
  templateUrl: './op-confirm-dialog.component.html',
  styleUrls: ['./op-confirm-dialog.component.scss']
})
export class OpConfirmDialogComponent implements OnInit {
  showOk: boolean = false;
  errorMessage: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<OpConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    if (this.data?.showOk) {
      this.showOk = true;
      this.errorMessage = this.data?.body?.split(',');

      //#7542 - Removing SQL error check as WAG will not send SQL error. Will revisit if needed.
      if(this.errorMessage.length == 1 && this.errorMessage[0].includes('Customer Id')){
        this.errorMessage[0] = 'Please reach out to the RxIT team to review this error : Customer Id not belongs to provided Integrator Id. This could be due to a lack of database migration.';
      }
      else if (!this.errorMessage && this.data?.errors?.length > 0) {
        this.errorMessage = this.data?.errors;
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
